import styled from 'styled-components';
import { Subtitle2Text } from '@/utils/global-fonts';
import { Col, Row } from '@/components/grid/grid-component';

const Supplier = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  padding: 32px;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  border: 1px solid
    ${({ selected, theme }) =>
      selected ? theme.COLOR_PRIMARY : theme.COLOR_GREY2};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.COLOR_WHITE};
  transition: all 0.2s ease-in-out;
  @media (hover: hover) {
    &:hover {
      border: 1px solid ${({ theme }) => theme.COLOR_GREY1};
      .prodCatTitle {
        color: ${({ theme }) => theme.COLOR_BLACK} !important;
      }
    }
  }
`;

const SupplierImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const SupplierWrapper = styled(Col)`
  height: unset;
`;

const Container = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
  vertical-align: middle;
  max-width: 1000px;
  padding-top: 32px;

  @media (max-width: 825px) {
    padding: 12px 24px;
  }
`;

const SupplierLogoImg = styled.img`
  width: 100%;
  height: auto;
  max-height: 150px;
  object-fit: contain;
`;

const SupplierLogoAlternative = styled(Subtitle2Text)`
  width: 100%;
  text-align: center;
  font-weight: 900;
  font-size: 22px;
  font: Mark Pro;
  color: ${({ theme }) => theme.COLOR_GREY3};
  padding: 15px 15px;
  border: 1px solid ${({ theme }) => theme.COLOR_GREY5};
  letter-spacing: 7%;
`;

const SupplierLabel = styled(Subtitle2Text)`
  color: ${({ theme }) => theme.COLOR_GREY_TEXT};
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.2px;
  margin-top: 32px;
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const SupplierRow = styled(Row)`
  row-gap: 30px;
  margin-top: 40px;
`;

const StyledSupplier = {
  Supplier,
  Container,
  SupplierLogoImg,
  SupplierLabel,
  SupplierLogoAlternative,
  LoaderContainer,
  SupplierWrapper,
  SupplierRow,
  SupplierImageContainer,
};

export default StyledSupplier;
